/* Once Upon Magic — NEO 2026 — local recently viewed memory */
(() => {
  const STORAGE_KEY = 'oum:recent-products:v1';
  const MAX_ITEMS = 8;
  const preferencesAllowed = () => window.OUMPrivacy?.resolved === true && window.OUMPrivacy.preferencesAllowed === true;
  const clearMemory = () => { try { localStorage.removeItem(STORAGE_KEY); } catch (_) {} };

  const templateName = () => {
    const main = document.querySelector('main[data-template]');
    return (main?.dataset.template || '').split('.')[0];
  };

  const readMemory = () => {
    if (!preferencesAllowed()) return [];
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item?.url && item?.title) : [];
    } catch (_) {
      return [];
    }
  };

  const writeMemory = (items) => {
    if (!preferencesAllowed()) return;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS))); } catch (_) {}
  };

  const formatPrice = (amount, currency) => {
    const numeric = Number(amount);
    if (!Number.isFinite(numeric) || !currency) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(numeric);
    } catch (_) {
      return `${amount} ${currency}`;
    }
  };

  const rememberProduct = () => {
    if (!preferencesAllowed() || templateName() !== 'product') return;

    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href.split('?')[0];
    const title = document.querySelector('main h1')?.textContent?.trim()
      || document.querySelector('meta[property="og:title"]')?.content?.trim()
      || document.title;
    const image = document.querySelector('meta[property="og:image:secure_url"]')?.content
      || document.querySelector('meta[property="og:image"]')?.content
      || '';
    const amount = document.querySelector('meta[property="product:price:amount"]')?.content || '';
    const currency = document.querySelector('meta[property="product:price:currency"]')?.content || '';
    const fallbackPrice = document.querySelector('.price')?.textContent?.replace(/\s+/g, ' ')?.trim() || '';
    const price = formatPrice(amount, currency) || fallbackPrice.slice(0, 80);

    if (!canonical || !title) return;

    const item = {
      url: canonical,
      title: title.slice(0, 180),
      image,
      price,
      seenAt: Date.now()
    };
    const next = [item, ...readMemory().filter((entry) => entry.url !== canonical)];
    writeMemory(next);
  };

  const createCard = (item) => {
    const card = document.createElement('a');
    card.className = 'oum-memory-card';
    card.href = item.url;
    card.setAttribute('role', 'listitem');

    const media = document.createElement('span');
    media.className = 'oum-memory-card__media';
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    } else {
      media.classList.add('oum-memory-card__media--empty');
      media.setAttribute('aria-hidden', 'true');
    }

    const body = document.createElement('span');
    body.className = 'oum-memory-card__body';
    const micro = document.createElement('small');
    micro.textContent = 'Revoir';
    const title = document.createElement('strong');
    title.textContent = item.title;
    body.append(micro, title);
    if (item.price) {
      const price = document.createElement('span');
      price.className = 'oum-memory-card__price';
      price.textContent = item.price;
      body.appendChild(price);
    }

    const arrow = document.createElement('span');
    arrow.className = 'oum-memory-card__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '↗';
    card.append(media, body, arrow);
    return card;
  };

  const renderShelf = () => {
    if (!preferencesAllowed() || templateName() !== 'index' || document.querySelector('[data-oum-memory-shelf]')) return;
    const items = readMemory();
    if (!items.length) return;

    const anchor = document.querySelector('#oum-magic-swipe')?.closest('.shopify-section')
      || document.querySelector('#oum-magic-swipe');
    if (!anchor) return;

    const section = document.createElement('section');
    section.className = 'oum-memory-shelf';
    section.dataset.oumMemoryShelf = 'true';
    section.setAttribute('aria-labelledby', 'OumMemoryShelfTitle');
    section.innerHTML = `
      <div class="oum-memory-shelf__inner">
        <header class="oum-memory-shelf__header">
          <div>
            <p class="oum-neo-eyebrow">Mémoire magique</p>
            <h2 id="OumMemoryShelfTitle">Vous les aviez remarqués.</h2>
            <p>Retrouvez instantanément les pièces consultées récemment sur cet appareil.</p>
          </div>
          <button type="button" class="oum-memory-shelf__clear" data-oum-memory-clear>Effacer l’historique</button>
        </header>
        <div class="oum-memory-shelf__track" data-oum-memory-track role="list" aria-label="Produits consultés récemment"></div>
      </div>`;

    const track = section.querySelector('[data-oum-memory-track]');
    items.forEach((item) => track?.appendChild(createCard(item)));
    anchor.insertAdjacentElement('afterend', section);

    section.querySelector('[data-oum-memory-clear]')?.addEventListener('click', () => {
      clearMemory();
      section.remove();
    });
  };

  let booted = false;
  let remembered = false;
  const syncPrivacy = () => {
    if (!booted) return;
    if (!preferencesAllowed()) {
      document.querySelector('[data-oum-memory-shelf]')?.remove();
      // Pending consent never reads history. A resolved refusal also removes it.
      if (window.OUMPrivacy?.resolved === true) clearMemory();
      remembered = false;
      return;
    }
    if (!remembered) { rememberProduct(); remembered = true; }
    renderShelf();
  };
  // A microtask also handles a core that publishes its API after emitting readiness.
  window.addEventListener('oum:privacy-change', () => queueMicrotask(syncPrivacy));
  const boot = () => {
    booted = true;
    syncPrivacy();
    window.OUMPrivacy?.ready?.then(syncPrivacy);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
